/**
 * Asynchronously loads the component for ReservationWidgetContainer
 */
import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./ReservationWidgetContainer'),
  loading: () => null,
});
